import { DateTime } from 'luxon';
import { parse } from 'query-string';
import { useMemo } from 'react';
import { QueryParam } from 'utils/constants/queryParam';
import { getQueryParam } from 'utils/queryStringUtils';
import { getSchedulingTimeRangeFromParamString } from '../utils/utils';
import useCalendarView from './useCalendarView';

export function useSchedulingTimeRange() {
  const stringTime = getQueryParam(parse(location.search), QueryParam.TIME, DateTime.local().toFormat('M-d-yyyy'));
  const currentView = useCalendarView();

  return useMemo(() => {
    return getSchedulingTimeRangeFromParamString(stringTime, currentView);
  }, [currentView, stringTime]);
}
